<template>
    <page :busy="busy" :tabs="tabs">
        <div class="cancellation-policy-list">
            <grid
                ref="grid"
                :columnDefs="columnDefs"
                :fetchCallback="fetchCallback"
                :suppressScrollOnNewData="true"
                :isAutoHeight="false"
                :groupDefaultExpanded="null"
                :onCellClicked="onCellClicked"
            >
                <div v-if="cancellationPoliciesTemplates.length">
                    <div class="cancellation-policy-toolbar mb-3 mr-1">
                        <form-select
                            :options="cancellationPoliciesOptions"
                            v-model="selectedCancellationPolicy"
                            @input="removeFocus"
                            class="remove-focus-from-select"
                        ></form-select>
                        <responsive-button
                            class="remove-focus-from-button"
                            variant="primary"
                            :icon="['fas', 'pen-to-square']"
                            @click="$bvModal.show(editCancellationPolicyModalId)"
                        ></responsive-button>
                        <responsive-button
                            v-if="!isDefault"
                            class="remove-focus-from-button"
                            variant="primary"
                            :icon="['fas', 'minus']"
                            @click="$bvModal.show(deleteCancellationPolicyModalId)"
                        ></responsive-button>
                        <responsive-button
                            class="remove-focus-from-button"
                            variant="primary"
                            :icon="['fas', 'copy']"
                            @click="$bvModal.show(cloneCancellationPolicyModalId)"
                        ></responsive-button>
                        <responsive-button
                            class="remove-focus-from-button"
                            variant="primary"
                            :icon="['fas', 'plus']"
                            @click="$bvModal.show(addCancellationPolicyModalId)"
                        ></responsive-button>
                    </div>
                    <div class="small">
                        <b>
                            To set a cancellation policy for the channels, please go to the
                            <a href="/app/partner/" class="text-primary">Integrations page</a>
                        </b>
                    </div>
                </div>
            </grid>
        </div>

        <add-edit-cancel-policy-modal
            :key="addCancellationPolicyModalKey"
            ref="add_cancellation_policy_modal"
            :modalId="addCancellationPolicyModalId"
            :modal-busy="cancellationPolicyModalBusy"
            @hidden="onHideModal"
            @submit="createCloneCancellationPolicy"
        />
        <add-edit-cancel-policy-modal
            :key="editCancellationPolicyModalKey"
            ref="edit_cancellation_policy_modal"
            :modalId="editCancellationPolicyModalId"
            :modal-busy="cancellationPolicyModalBusy"
            @hidden="onHideModal"
            @submit="updateCancellationPolicy"
            :policy="currentCancellationPolicy"
        />
        <add-edit-cancel-policy-modal
            :key="cloneCancellationPolicyModalKey"
            ref="clone_cancellation_policy_modal"
            :modalId="cloneCancellationPolicyModalId"
            :modal-busy="cancellationPolicyModalBusy"
            @hidden="onHideModal"
            @submit="createCloneCancellationPolicy"
            :policy="currentCancellationPolicy"
            :clone="true"
        />
        <modal
            :id="deleteCancellationPolicyModalId"
            title="Warning"
            @hidden="onHideModal"
            @ok="removeCancellationPolicy"
        >
            Are you sure you want to delete this Cancellation Policy? All associations with properties will be lost.
        </modal>
        <modal :id="descriptionContentModalId" title="Description" size="lg" ok-title="Close" scrollable ok-only>
            <div style="white-space: pre-wrap;">
                {{ descriptionContent }}
            </div>
        </modal>
    </page>
</template>

<script>
    import isEmpty from 'lodash/isEmpty';
    import FormSelect from '../../generic/form-select/form-select.vue';
    import page from '../../generic/page/page.vue';
    import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';
    import AddEditCancelPolicyModal from './add-edit-cancel-policy-modal.vue';
    import {
        CANCELLATION_POLICIES_SET_PROPERTY_ENDPOINT,
        CANCELLATION_POLICY_TEMPLATE_ENDPOINT,
    } from '../../../endpoints';
    import API from '../../../api';
    import Grid from '../../generic/grid/grid.vue';
    import Modal from '../../generic/modal/modal.vue';
    import FormSquareSwitch from '../../generic/form-square-switch/form-square-switch.vue';
    import FormInput from '../../generic/form-input/form-input.vue';
    import FormTextarea from '../../generic/form-textarea/form-textarea.vue';
    import { toAmountDisplay } from '../../../utils/numbers';
    import { formatResponseError } from '../../../utils/api';
    export default {
        components: {
            page,
            FormSelect,
            ResponsiveButton,
            Grid,
            Modal,
            FormSquareSwitch,
            FormInput,
            FormTextarea,
            AddEditCancelPolicyModal,
        },
        name: 'CancellationPoliciesList',
        data() {
            return {
                tabs: [
                    {
                        id: 'policies',
                        title: 'Policies',
                        active: false,
                        route: '/app/policy/list',
                    },
                    {
                        id: 'cancellation_policies',
                        title: 'Cancellation Policies',
                        active: true,
                        route: '/app/policy/cancellation-policy/list',
                    },
                    {
                        id: 'amenities_manager',
                        title: 'Amenities',
                        active: false,
                        route: '/app/policy/amenity-manager/list',
                    },
                    {
                        id: 'meta_data_manager',
                        title: 'Amenity Metadata',
                        active: false,
                        route: '/app/policy/meta-data/list',
                    },
                ],
                busy: null,
                cancellationPolicyModalBusy: false,
                selectedCancellationPolicy: null,
                cancellationPoliciesOptions: [],
                cancellationPoliciesTemplates: [],
                offset: 0,
                limit: 20,
                sort: 'id',
                desc: false,
                search: '',
                editMode: false,
                cloneMode: false,
                descriptionContent: '',
                descriptionContentModalId: 'description-content-model-id',
                addCancellationPolicyModalId: 'add-cancellation-policy-modal-id',
                addCancellationPolicyModalKey: 'addCancellationPolicyModalKey',
                editCancellationPolicyModalKey: 'editCancellationPolicyModalKey',
                cloneCancellationPolicyModalKey: 'cloneCancellationPolicyModalKey',
            };
        },
        mounted() {
            this.fetchCancellationPolicyTemplates();
        },
        methods: {
            onHideModal() {
                this.cloneCancellationPolicyModalKey += 1;
                this.addCancellationPolicyModalKey += 1;
                this.editCancellationPolicyModalKey += 1;
                this.$nextTick(() => {
                    document.querySelectorAll('.remove-focus-from-button').forEach((item) => item.blur());
                });
            },
            removeFocus(e) {
                document.querySelector('.remove-focus-from-select .custom-select').blur();
            },
            onCellClicked({ column, data }) {
                if (column.colId === 'cancellation_policy.description') {
                    this.descriptionContent = data.cancellation_policy.description;
                    this.$bvModal.show(this.descriptionContentModalId);
                }
            },
            async createCloneCancellationPolicy(values, isClone) {
                try {
                    this.cancellationPolicyModalBusy = true;
                    const { data } = await API.post(CANCELLATION_POLICY_TEMPLATE_ENDPOINT(), values);
                    this.$bvModal.hide(
                        isClone ? this.cloneCancellationPolicyModalId : this.addCancellationPolicyModalId
                    );
                    await this.fetchCancellationPolicyTemplates();
                    this.selectedCancellationPolicy = this.cancellationPoliciesOptions.find(
                        (item) => item.value === data.id
                    ).value;
                    this.$refs.grid.refreshDataSource();
                    this.successToast({ text: `Cancellation policy successfully ${isClone ? 'cloned' : 'created'}.` });
                    isClone ? (this.cloneCancellationPolicyModalKey += 1) : (this.addCancellationPolicyModalKey += 1);
                } catch (error) {
                    const { generic, fields } = formatResponseError(error);
                    if (!isEmpty(fields)) this.$refs.add_cancellation_policy_modal.setErrors(fields);
                    if (generic) this.errorToast({ text: generic });
                    else this.errorToast({ text: `Could not ${isClone ? 'clone' : 'create'} cancellation policy.` });
                } finally {
                    this.cancellationPolicyModalBusy = false;
                }
            },
            async updateCancellationPolicy(values, id) {
                try {
                    this.cancellationPolicyModalBusy = true;
                    await API.patch(CANCELLATION_POLICY_TEMPLATE_ENDPOINT(id), values);
                    this.$bvModal.hide(this.editCancellationPolicyModalId);
                    await this.fetchCancellationPolicyTemplates();
                    this.selectedCancellationPolicy = this.cancellationPoliciesOptions.find(
                        (item) => item.value === id
                    ).value;
                    this.$refs.grid.refreshDataSource();
                    this.successToast({ text: `Cancellation policy successfully updated.` });
                    this.editCancellationPolicyModalKey += 1;
                } catch (error) {
                    const { generic, fields } = formatResponseError(error);
                    if (!isEmpty(fields)) this.$refs.edit_cancellation_policy_modal.setErrors(fields);
                    if (generic) this.errorToast({ text: generic });
                    else this.errorToast({ text: 'Could not update cancellation policy.' });
                } finally {
                    this.cancellationPolicyModalBusy = false;
                }
            },
            async removeCancellationPolicy() {
                try {
                    this.busy = true;
                    await API.delete(CANCELLATION_POLICY_TEMPLATE_ENDPOINT(this.selectedCancellationPolicy));
                    this.$bvModal.hide('delete-cancellation-policy' + this.selectedCancellationPolicy);
                    await this.fetchCancellationPolicyTemplates();
                    this.$refs.grid.refreshDataSource();
                    this.successToast({ text: `Cancellation policy successfully deleted.` });
                } catch (error) {
                    this.errorToast({ text: 'Could not delete cancellation policy' });
                    return;
                } finally {
                    this.busy = false;
                }
            },
            async fetchCancellationPolicyTemplates() {
                try {
                    this.busy = true;
                    const { data } = await API.get(CANCELLATION_POLICY_TEMPLATE_ENDPOINT());
                    this.cancellationPoliciesTemplates = data;
                    this.cancellationPoliciesOptions = data.map((item) => ({
                        value: item.id,
                        text: item.name,
                        default: item.default,
                    }));
                    this.selectedCancellationPolicy = this.cancellationPoliciesOptions.find(
                        (item) => item.default
                    ).value;
                } catch (e) {
                    this.errorToast({ text: 'Could not fetch cancellation policies.' });
                } finally {
                    this.busy = false;
                }
            },
            getPolicyName({ data }) {
                if ({ data }) {
                    return data.cancellation_policy.template.name;
                }
            },
        },
        computed: {
            columnDefs() {
                return [
                    {
                        field: 'id',
                        headerName: 'Lodgix ID',
                        maxWidth: 120,
                        sort: 'asc',
                    },
                    {
                        field: 'name',
                        headerName: 'Property',
                    },
                    {
                        field: 'cancellation_policy.cancellation_fee',
                        headerName: 'Cancellation Fee',
                        type: 'amountColumn',
                        maxWidth: 145,
                    },
                    {
                        field: 'cancellation_policy.description',
                        headerName: 'Description',
                        sortable: false,
                        maxWidth: 400,
                    },
                    {
                        field: 'refunds_description',
                        headerName: 'Refunds',
                        sortable: false,
                        autoHeight: true,
                        cellRenderer: ({ data }) => {
                            return data.cancellation_policy && data.cancellation_policy.periods
                                ? data.cancellation_policy.periods
                                      .map(
                                          (item) =>
                                              `${toAmountDisplay({
                                                  amount: item.refund_percent,
                                                  percentage: true,
                                              })} refund if ${item.nights_before_checkin} days before arrival`
                                      )
                                      .join('<br/>')
                                : '';
                        },
                    },
                    {
                        field: 'cancellation_policy.template',
                        colId: 'cancellation_policy.template.name',
                        headerName: 'Cancellation Policy',
                        cellEditor: 'selectCellEditor',
                        editable: true,
                        cellClass: 'text-primary lx-editable-cell',
                        getQuickFilterText: (params) => {
                            if (params.data) return params.data.cancellation_policy.template.name;
                        },
                        cellEditorParams: () => ({
                            options: this.cancellationPoliciesOptions,
                        }),
                        cellRenderer: (params) => params.data && this.getPolicyName(params),
                        valueGetter: (params) => {
                            if (
                                params.data &&
                                params.data.cancellation_policy &&
                                params.data.cancellation_policy.template
                            ) {
                                return (
                                    params.data.cancellation_policy.template &&
                                    params.data.cancellation_policy.template.id
                                );
                            }
                        },
                        valueSetter: async ({ node, data, newValue, oldValue, api }) => {
                            (async () => {
                                try {
                                    await API.post(CANCELLATION_POLICIES_SET_PROPERTY_ENDPOINT(newValue, data.id));
                                    setTimeout(function() {
                                        api.redrawRows();
                                    }, 0);
                                } catch (e) {
                                    this.errorToast({ text: 'Could not update property' });
                                    data.cancellation_policy.template = this.cancellationPoliciesTemplates.find(
                                        (p) => p.id === oldValue
                                    );
                                    node.setData(data);
                                }
                            })();
                            const policy = this.cancellationPoliciesTemplates.find((p) => p.id === newValue);
                            data.cancellation_policy = policy ? { ...policy } : { id: null, cancellation_fee: 0 };
                            data.cancellation_policy.template = policy ? policy : null;
                            return true;
                        },
                    },
                ];
            },
            fetchCallback() {
                return ({ offset, limit, sort, desc, search }) => {
                    this.offset = offset;
                    this.limit = limit;
                    this.sort = sort;
                    this.desc = desc;
                    this.search = search;
                    return API.get('/app/property/property/cancellation-policy-grid/', {
                        params: { offset, limit, sort, desc, search },
                    });
                };
            },
            isDefault() {
                return this.cancellationPoliciesTemplates.some(
                    (item) => item.id === this.selectedCancellationPolicy && item.default
                );
            },
            editCancellationPolicyModalId() {
                return 'edit-cancellation-policy' + this.selectedCancellationPolicy;
            },
            cloneCancellationPolicyModalId() {
                return 'clone-cancellation-policy' + this.selectedCancellationPolicy;
            },
            deleteCancellationPolicyModalId() {
                return 'delete-cancellation-policy' + this.selectedCancellationPolicy;
            },
            currentCancellationPolicy() {
                return this.cancellationPoliciesTemplates.find((item) => item.id === this.selectedCancellationPolicy);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    :deep(.select-policy) {
        padding-top: 10px;
        .ag-cell-value {
            width: 100%;
        }
    }
    .cancellation-policy-list {
        height: 100%;
    }

    @include media-breakpoint-down(xl) {
        .cancellation-policy-list {
            overflow: hidden;
            padding-bottom: 40px;
        }
    }

    @include media-breakpoint-down(md) {
        .cancellation-policy-list {
            overflow: auto;
        }
    }

    .cancellation-policy-toolbar {
        display: flex;
        align-items: center;
        .form-group {
            margin-bottom: 0;
            :deep(.custom-select) {
                border-top-right-radius: 0 !important;
                border-bottom-right-radius: 0 !important;
            }
        }
        .btn {
            margin-right: 0 !important;
            &:not(:last-child) {
                border-radius: 0;
            }
            &:last-child {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }
        }
    }

    .toggle-item .v-switch-label {
        padding-top: 0.2em !important;
    }

    .toggle-item .v-switch-core {
        height: 2.35em !important;
    }

    .toggle-item .v-switch-button {
        top: 0.18em !important;
        height: 2em !important;
    }
    .toggle-item {
        margin-right: 1rem !important;
    }
    @media (max-width: 360px) {
        .toggle-item .vue-js-switch {
            width: 65px !important;
        }
        .toggle-item .v-switch-label {
            font-weight: 600 !important;
            font-size: 14px !important;
        }
        .toggle-item {
            margin-right: 0.2rem !important;
        }
    }
</style>
